module.exports = __webpack_public_path__ + "src/assets/games/42/31.jpg";